import React, { useContext, useEffect } from "react";
import Header from "../Components/Header";
import Rightcontainer from "../Components/Rightcontainer";
import { Link } from "react-router-dom";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";

const Support = ({ handleShow }) => {
  const theme = localStorage.getItem("theme");
  const MyData = localStorage.getItem("udata");
  const meedata = JSON.parse(MyData);

  const history = useHistory();

  useEffect(() => {
    if (meedata.verified == "unverified") {
      Swal.fire({
        icon: "warning",
        html: `
    <h4 style="color:white; margin-bottom:10px;">
      Please complete KYC
    </h4>
    <p style="color:white;">
      You need to complete your KYC before proceeding.
    </p>
  `,
        background: "linear-gradient(135deg, #1e3a8a, #0f172a)",
        confirmButtonText: "Verify Now",
        confirmButtonColor: "#f59e0b",
      }).then((result) => {
        if (result.isConfirmed) {
          history.push("/Profile"); // ✅ redirect
        }
      });

      return;
      //  history.push("/Profile");
    }
  }, []);
  // language
  const translations = {
    hi: {
      contact: "नीचे दिए गए प्लेटफ़ॉर्म पर हमसे संपर्क करें।",
      money: "राशि डालें  ",
      next: "आगे बड़े ",
      addAmount: "राशि जोड़ी जानी है ",
      referPerson: "रेफ़रल | ",
    },
    en: {
      contact: "Contact Us At Below Platforms.",
      money: "Enter Amount",
      next: "Next",
      addAmount: "Amount to be added",
      referPerson: "Referral",
    },
  };

  const { language } = useContext(LanguageContext);

  // change theme
  const styles = {
    backgroundColor: theme === "light" ? "#fffff0" : "black",
    color: theme === "light" ? "black" : "#fff",
  };
  const styles1 = {
    color: theme === "light" ? "black" : "white",
  };

  return (
    <div>
      <div className="leftContainer mb_space">
        <div className="Orher_page_main_section">
          <div className=" ">
            <div className="profile_headings mt-4" style={{ ...styles1 }}>
              {translations[language].contact}
            </div>
            <div className="row mt-3">
              {/* youtube */}
              {/* <div className="col-6 col-lg-4 col-md-3 col-sm-12 mb-3">
                <div className="support_samll_card_btn_type">
                  <a
                    className="cxy flex-column"
                    target="_blank"
                    href="https://youtu.be/0hNHiccgoMI?si=njTT0HryRxmQtWq7"
                  >
                    <img width="50px" src="/images/youtube.png" alt="" />
                    <span className="">Youtube</span>
                  </a>
                </div>
              </div> */}

              {/* mail */}
              {/* <div className="col-6 col-lg-4 col-md-3 col-sm-12 mb-3">
                <div className="support_samll_card_btn_type">
                  <a className="cxy flex-column" href="mailto:info@khelstar.com">
                    <img
                      width="50px"
                      src={process.env.PUBLIC_URL + "/images/mail.png"}
                      alt=""
                    />
                    <span className="">
                      {JSON.parse(localStorage.getItem("sitSetting")) ==
                      "undefined"
                        ? ""
                        : JSON.parse(localStorage.getItem("sitSetting"))
                            ?.supportMail}
                    </span>
                  </a>
                </div>
              </div> */}

              {/* whatsapp */}
              {/* <div className="col-6 col-lg-4 col-md-3 col-sm-12 mb-3">
                <div className="support_samll_card_btn_type">
                  {JSON.parse(localStorage.getItem("sitSetting")) ==
                  "undefined" ? (
                    ""
                  ) : JSON.parse(localStorage.getItem("sitSetting"))
                      ?.whatsappSupport ? (
                    <>
                      <a
                        href={
                          JSON.parse(localStorage.getItem("sitSetting")) ==
                          "undefined"
                            ? ""
                            : JSON.parse(localStorage.getItem("sitSetting"))
                                ?.whatsappSupport
                        }
                        target="_blank"
                      >
                        <img
                          width="50px"
                          src={process.env.PUBLIC_URL + "/images/whatsapp.png"}
                          alt=""
                        />
                        <span className="">WhatsApp</span>
                      </a>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div> */}
              {/* call */}
              {/* <div className="col-6 col-lg-4 col-md-3 col-sm-12 mb-3">
                <div className="support_samll_card_btn_type">
                  <img
                    width="50px"
                    src={process.env.PUBLIC_URL + "/images/phone.png"}
                    alt=""
                  />
                  <span className="">
                    <a
                      target="_blank"
                      href={
                        JSON.parse(localStorage.getItem("sitSetting")) ==
                        "undefined"
                          ? ""
                          : "tel:" +
                            JSON.parse(localStorage.getItem("sitSetting"))
                              ?.CompanyMobile
                      }
                    >
                      {JSON.parse(localStorage.getItem("sitSetting")) ==
                      "undefined"
                        ? ""
                        : JSON.parse(localStorage.getItem("sitSetting"))
                            ?.CompanyMobile}
                    </a>
                  </span>
                </div>
              </div> */}
              {/* support-bx */}
              <div className="col-lg-12">
                <div className="support-bx">
                  <h6>Customer Support</h6>
                  {/* <div className="d-flex align-items-center border-down pb-3">
                      <div className="support-icon">
                          <img src="/phonee.png" alt="" />
                      </div>
                      <div>
                        <h4 className="mb-2" style={{color:"black"}}>Phone Support</h4>
                        <h4 className="mb-0">
                        <a
                      target="_blank"
                      href={
                        JSON.parse(localStorage.getItem("sitSetting")) ==
                        "undefined"
                          ? ""
                          : "tel:" +
                            JSON.parse(localStorage.getItem("sitSetting"))
                              ?.CompanyMobile
                      }
                    >
                      {JSON.parse(localStorage.getItem("sitSetting")) ==
                      "undefined"
                        ? ""
                        : JSON.parse(localStorage.getItem("sitSetting"))
                            ?.CompanyMobile}
                    </a>
                        </h4>
                      </div>
                  </div> */}
                  {/* <div className="d-flex align-items-center border-down py-3 ">
                    <>
                      {JSON.parse(localStorage.getItem("sitSetting")) ==
                      "undefined" ? (
                        ""
                      ) : JSON.parse(localStorage.getItem("sitSetting"))
                          ?.whatsappSupport ? (
                        <>
                          <a
                            href={
                              JSON.parse(localStorage.getItem("sitSetting")) ==
                              "undefined"
                                ? ""
                                : JSON.parse(localStorage.getItem("sitSetting"))
                                    ?.whatsappSupport
                            }
                            target="_blank"
                          >
                            <div style={{ display: "flex" }}>
                              <div className="support-icon">
                                <img src="/whatsapp.png" alt="" />
                              </div>
                              <div>
                                <h4
                                  className="mb-0"
                                  style={{ color: "black", marginTop: "6%" }}
                                >
                                  Whatsapp Support
                                </h4>
                              </div>
                            </div>
                          </a>
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  </div> */}

                  <div className="d-flex align-items-center border-down py-3 ">
                    <>
                      {JSON.parse(localStorage.getItem("sitSetting")) ==
                      "undefined" ? (
                        ""
                      ) : JSON.parse(localStorage.getItem("sitSetting"))
                          ?.supportTelegram ? (
                        <>
                          <a
                            href={
                              JSON.parse(localStorage.getItem("sitSetting")) ==
                              "undefined"
                                ? ""
                                : JSON.parse(localStorage.getItem("sitSetting"))
                                    ?.supportTelegram
                            }
                            target="_blank"
                          >
                            <div style={{ display: "flex" }}>
                              <div className="support-icon">
                                <img src="/images/tel.png" alt="" />
                              </div>
                              <div>
                                <h4
                                  className="mb-0"
                                  style={{ color: "black", marginTop: "6%" }}
                                >
                                  Telegram Support
                                </h4>
                              </div>
                            </div>
                          </a>
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  </div>

                  {/* <div className="d-flex align-items-center pt-3" >
                  <a href="mailto:info@khelstar.com" style={{display:"contents"}}>
                      <div className="support-icon">
                          <img src="/email.png" alt="" />
                      </div>
                      <div>
                        <h4 className="mb-0" style={{color:"black"}}>Email Support</h4>
                       
                      </div>
                      </a>
                  </div> */}
                </div>
              </div>

              {/* <div className="col-12 col-lg-12 col-md-12 col-sm-12 mb-3">
                <p className="company_address" style={styles}>
                 <span style={styles}>Address:</span> 
                  <span style={styles}>
                    {JSON.parse(localStorage.getItem("sitSetting")) ==
                    "undefined"
                      ? ""
                      : JSON.parse(localStorage.getItem("sitSetting"))
                          ?.CompanyAddress}
                  </span>
                </p>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </div>
  );
};

export default Support;
